module.exports = __webpack_public_path__ + "img/page-empty-list-dark.11aa4e3e.svg";